export class ConnectedAccountSessionManagement {
  constructor(readonly clientSecret: string) {}
}
